import { jsx, jsxs } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { useMemo } from "react";
const WarningWrapper = ({ classes, isShown, children, icon }) => {
  const { themeClasses } = useThemePresetClasses("WarningWrapper", classes);
  const displayIcon = useMemo(() => {
    if (isShown) {
      if (icon) {
        return icon;
      }
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: cn(
            "absolute -top-1 right-0 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-pink-500 text-sm",
            themeClasses == null ? void 0 : themeClasses.span
          ),
          children: "!"
        }
      );
    }
    return null;
  }, [isShown, icon, themeClasses == null ? void 0 : themeClasses.span]);
  return /* @__PURE__ */ jsxs("div", { className: cn("relative", themeClasses == null ? void 0 : themeClasses.root), children: [
    children,
    displayIcon
  ] });
};
const WarningWrapper$1 = WarningWrapper;
export {
  WarningWrapper$1 as default
};
